import React from "react";
import DashboardLayout from "./DashboardLayout";

/**
 * CreatorLayout - Dedicated layout wrapper for all Creator / Organisation pages.
 * Pre-sets role="creator", userRole="Creator".
 */
const CreatorLayout = (props) => {
  return (
    <DashboardLayout
      role="creator"
      userRole="Creator"
      {...props}
    />
  );
};

export default CreatorLayout;
